module.exports = __webpack_public_path__ + "static/media/desc.847e1040.svg";